"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("../../Button"));
var DeckStudyButton = function (_a) {
    var deck = _a.deck, other = __rest(_a, ["deck"]);
    // If there are no cards to review,
    // diable the button
    var disabled = deck.dueCount === 0;
    var label = disabled ? 'Nothing to review' : 'Study Deck';
    // If the cards are filtered
    if (!disabled &&
        (deck.filterCategory ||
            deck.filterSubcategories.length ||
            deck.filterNew ||
            deck.filterStarred ||
            deck.filterRetired)) {
        label = 'Study Filtered';
    }
    return (react_1.default.createElement(Button_1.default, __assign({ fullWidth: true, size: "large", variant: "flat", color: "primary", disabled: disabled, style: { whiteSpace: 'nowrap' } }, other), label));
};
exports.default = DeckStudyButton;
//# sourceMappingURL=DeckStudyButton.js.map